import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { connect } from 'react-redux';
import { useNCFileDetails } from '@v2/pages/common/hooks/useNCFileDetails';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByNCFile, operationsSearch } from '@reducers/search';
import { getPartByID } from '@reducers/parts';
import { getNCFileById, getNCFileByName } from '@reducers/manufacture';
import MultiMachineTimeline from '@v2/pages/common/components/MultiMachineTimeline';

interface NCFileDetailsPartTimelineProps {}

const NCFileDetailsPartTimelineComponent: FC<NCFileDetailsPartTimelineProps> = ({
  clearTools,
  getTools,
  getProductionBatchByNCFile,
  updateHeaderConfig,
  getPartByID,
  getNCFileById,
  operationsSearch,
  getNCFileByName,
}) => {
  const title = useTitle();

  useNCFileDetails({
    clearTools,
    getTools,
    updateHeaderConfig,
    getProductionBatchByNCFile,
    getPartByID,
    getNCFileById,
    operationsSearch,
    getNCFileByName,
  });

  return (
    <DetailsPageWrapper title={title.part}>
      <MultiMachineTimeline />
    </DetailsPageWrapper>
  );
};

const NCFileDetailsPartTimeline = connect(null, {
  clearTools,
  getTools,
  getProductionBatchByNCFile,
  updateHeaderConfig,
  getPartByID,
  getNCFileById,
  operationsSearch,
  getNCFileByName,
})(NCFileDetailsPartTimelineComponent);

export { NCFileDetailsPartTimeline };
